import { constantCase } from 'case-anything';

const generateLocaleId = label => {
  if (!label) {
    return label;
  }
  return constantCase(label);
};

export default generateLocaleId;
